import channels from './channels';
import comments from './comments';
import discussions from './discussions';

const forumAPIModule = {
  modules: {
    channels,
    comments,
    discussions,
  },
};

export default forumAPIModule;
